import React from 'react'
import { PaymentFailureIcon } from '../../assets/images'

const PaymentFailedModal = () => {
  return (
    <div
    className="modal fade"
    id="failure_popup"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabIndex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div className="succes_logo text-center mt-3">
          <img src={PaymentFailureIcon} className="mx-auto p-4" />
        </div>
        <div className="heading-logo text-center">
          <h4 className="success_text text-s">Payment Failure</h4>
        </div>
        <div className="modal-body mb-4">
          <div className="success_text w-75 mx-auto text-center">
            <p>
              Your payment has failed. Please confirm payment details and
              resubmit.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default PaymentFailedModal